import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { devWarn } from "@/lib/log";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [authed, setAuthed] = useState(null); // null=checking, true, false

  useEffect(() => {
    // Session lives in an httpOnly cookie — ask the backend if it's valid.
    api
      .get("/auth/verify")
      .then(() => setAuthed(true))
      .catch(() => setAuthed(false));
  }, []);

  const login = useCallback(async (password) => {
    await api.post("/auth/login", { password });
    setAuthed(true);
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      devWarn("Logout request failed", err);
    }
    setAuthed(false);
  }, []);

  const value = useMemo(() => ({ authed, login, logout }), [authed, login, logout]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
